import { render, staticRenderFns } from "./orderTabFirst.vue?vue&type=template&id=50a43ebe&scoped=true"
import script from "./orderTabFirst.vue?vue&type=script&lang=js"
export * from "./orderTabFirst.vue?vue&type=script&lang=js"
import style0 from "./orderTabFirst.vue?vue&type=style&index=0&id=50a43ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a43ebe",
  null
  
)

export default component.exports